import { apiGet } from './http-client';

export type MySubscriptionItem = {
  id: number;
  plan_name: string;
  plan_type: string;
  status: string;
  visits_total: number | null;
  visits_used: number;
  balance_total: string | number | null;
  balance_used: string | number;
  valid_until: string | null;
  branch_name: string | null;
  organization_id?: number;
  /** Обложка плана (если есть) — для акцента карточки в мобильном UI. */
  photo_url?: string | null;
  freeze_used_days: number;
  freeze_used_count: number;
  freeze_allowed_days: number;
  freeze_max_count: number;
};

/** GET /api/v1/subscriptions/my-subscriptions */
export function listMySubscriptions(accessToken: string): Promise<MySubscriptionItem[]> {
  return apiGet<MySubscriptionItem[]>('/api/v1/subscriptions/my-subscriptions', undefined, { accessToken });
}
